import { render, staticRenderFns } from "./TagsEditorModal.vue?vue&type=template&id=579dc938&scoped=true"
import script from "./TagsEditorModal.vue?vue&type=script&lang=js"
export * from "./TagsEditorModal.vue?vue&type=script&lang=js"
import style0 from "./TagsEditorModal.vue?vue&type=style&index=0&id=579dc938&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579dc938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579dc938')) {
      api.createRecord('579dc938', component.options)
    } else {
      api.reload('579dc938', component.options)
    }
    module.hot.accept("./TagsEditorModal.vue?vue&type=template&id=579dc938&scoped=true", function () {
      api.rerender('579dc938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/TagsEditorModal.vue"
export default component.exports